<template>
	<div class="overlay-dialog selfordering-login">
		<!-- <h2
			class="overlay-dialog__title"
			v-html="$t('account.addressEdit.title')"
		/> -->
		<template v-if="showPhoneForm">
			<h2 v-html="$t('account.selfordering.addPhoneTitle')"/>
			<p v-html="$t('account.selfordering.addPhoneText')"/>
			<ValidationObserver
				ref="phoneForm"
				v-slot="{ invalid, errors }"
				class=""
				tag="form"
				@submit.prevent="onPhoneUpdate"
				novalidate
			>
				<GeneralMessage
					v-if="phoneResponse.message"
					:message="phoneResponse.message"
					:type="phoneResponse.type"
					@close="phoneResponse.message = ''"
				/>
				<ValidationProvider
					class="input-wrapper"
					name="phone"
					rules="required|phone"
					v-slot="{ errors, invalid, validated }"
					tag="div"
					:customMessages="{ required: $t('forms.errors.fieldEmpty'), phone: $t('forms.errors.phone') }"
				>
					<FormInput
						type="tel"
						:placeholder="$t('forms.labels.phone')"
						:label="$t('forms.labels.phone')"
						v-model="phoneForm.phoneNumber"
						:error="errors.length > 0"
						required
					/>
					<span
						class="input-error"
						v-if="invalid && validated"
						v-html="errors[0]"
					/>
					<span class="additional-info" v-html="$t('login.phoneHint')"/>
				</ValidationProvider>

				<Button
					type="submit"
					level="primary"
					:text="$t('account.safeButton')"
				/>
			</ValidationObserver>
		</template>
		<div class="selfordering-login__details" v-else>
			<h2 v-html="$t('account.selfordering.qrcodeTitle')" />
			<p v-html="$t('account.selfordering.qrcodeText')" />

			<QRCode
				:content="accountQrTokenPrefixed"
			/>
		</div>
	</div>
</template>

<script>
import Vue from "vue"
import { mapGetters } from "vuex"
import { ValidationProvider, ValidationObserver } from "vee-validate"
import FormInput from '@/components/FormInput';
import GeneralMessage from '@/components/GeneralMessage'
import Button from '@/components/Button';
import QRCode from '@/components/QRCode';
import htmlComponent from 'htmlcomponent'

export default {
	components: {
		ValidationProvider,
		ValidationObserver,
		FormInput,
		GeneralMessage,
		Button,
		QRCode,
	},
	data() {
		return {
			phoneForm: {
				phoneNumber: '',
			},
			phoneResponse: {
				type: 'info',
				message: '',
			},
			showPhoneForm: false,
		};
	},
	computed: {
		...mapGetters("account", [
			"isLoggedIn",
			"accountUserDetail",
			"accountQrToken",
			"accountQrTokenPrefixed",
		]),
		...mapGetters('loader', [
			'isLoading',
		]),
		loading: {
			set(value) {
				this.$store.dispatch('loader/setLoading', value);
				this.$emit('loading', value);
			},
			get() {
				return this.isLoading;
			}
		},
	},
	methods: {
		async onPhoneUpdate() {
			const isValid = await this.$refs.phoneForm.validate()
			if (isValid) {
				this.loading = true;
				document.activeElement.blur();
				try {
					await this.$store.dispatch('account/updateUser', {
						...this.accountUserDetail,
						...this.phoneForm,
					})
					this.$refs.phoneForm.reset();
					this.phoneForm.phoneNumber = '';
					this.phoneResponse.message = '';
					this.phoneResponse.type = 'info';
					this.showPhoneForm = false;
				} catch(err) {
					let message = err && err.response && err.response.data ? err.response.data.message : this.$t('forms.errors.generic')
					this.phoneResponse.message = message;
					this.phoneResponse.type = 'error';
				}
				this.loading = false;
			}
		},
	},
	created() {
		this.loading = true;
	},
	async mounted() {
		this.phoneForm.phoneNumber = this.accountUserDetail.phoneNumber || '';
		this.showPhoneForm = !this.accountUserDetail.phoneNumber;
		await this.$store.dispatch('account/loadQRToken');
		this.loading = false;
	}
}
</script>

<style>

</style>